export const SITE = {
  name: "MatCalc360",
  domain: "https://matcalc360.com",
  appBaseUrl: "https://matcalc360.pro",
  tagline: "Construction material calculators for people who build.",
};

export const NAV_LINKS = [
  { label: "Calculators", href: "/" },
  { label: "How It Works", href: "#how-it-works" },
  { label: "FAQ", href: "#faq" },
];

export const MARQUEE_ITEMS = [
  "ROOFING",
  "CONCRETE",
  "ASPHALT",
  "BRICK",
  "STONE",
  "LUMBER",
  "SIDING",
  "PAINT",
  "DRYWALL",
  "LANDSCAPING",
  "MULCH",
  "FREE · NO LOGIN",
];

export const HOW_IT_WORKS_STEPS = [
  {
    number: "01",
    title: "Enter your measurements",
    body: "Length, width, depth, pitch — the numbers you already pace off on site. No blueprints, no signup, no spreadsheet.",
  },
  {
    number: "02",
    title: "Calculate materials",
    body: "The calculator applies the right formulas, density factors and waste allowances for your specific material.",
  },
  {
    number: "03",
    title: "Get your results",
    body: "Squares, yards, tons, boards or sheets — a clean order list you can hand straight to the supplier.",
  },
];

export const FOOTER_COMPANY_LINKS = [
  { label: "About MatCalc360", href: "https://matcalc360.pro/about" },
  { label: "Contact", href: "https://matcalc360.pro/contact" },
  { label: "Privacy Policy", href: "https://matcalc360.pro/privacy" },
  { label: "Terms of Use", href: "https://matcalc360.pro/terms" },
];
